<template>
  <v-layout row>
    <v-flex xs12 sm12  lg12>
      <v-card>
        <v-card-title primary-title>
          <h3 class="headline mb-0">{{ $t('quote.create-form.edit') }} </h3>
        </v-card-title>
        <v-card-text>
          <v-form action="">
            <v-select
              v-model="data.quotes_category_id"
              :error="validated.error"
              :error-messages="validated.message"
              :items="category"
              :label="$t('event.create-form.category')"
              item-text="label"
              item-value="value"
            ></v-select>
            <v-text-field
              :label="$t('event.create-form.description')"
              v-model="data.description"
              name="description"
            ></v-text-field>
            <v-checkbox
              v-if="showAll"
              label="¿Todo el colegío?"
              name="all"
              v-model="data.all"
            ></v-checkbox>
            <v-autocomplete
              v-if="showSchool"
              multiple
              v-model="data.schools"
              :error="validated.error"
              :error-messages="validated.message"
              :items="selectScool"
              label="Escuelas"
              item-text="value"
              item-value="id"
            ></v-autocomplete>
            <v-select
              v-if="showDegree"
              multiple
              v-model="data.degrees"
              :error="validated.error"
              :error-messages="validated.message"
              :items="selectDegrees"
              label="Grados"
              item-text="name"
              item-value="id"
            ></v-select>
            <v-checkbox
              v-show="showExternal"
              label="¿Personas externas?"
              name="external"
              v-model="data.external"
            ></v-checkbox>

            <v-card v-if="showPerson">
              <v-card-title >Asitencia padres</v-card-title>
              <v-autocomplete
                v-if="showPerson"
                :search-input.sync="search"
                v-model="data.families"
                :items="resultFami"
                no-data-text="No hay datos para la busqueda"
                :loading="isLoading"
                item-text="name"
                item-value="id"
                label="Buscar Familia"
                multiple
              ></v-autocomplete>
              <v-divider v-if="showPerson"></v-divider >
              <v-expand-transition v-show="showPerson">
                <v-item-group multiple>
                  <v-subheader v-show="showPerson">Familias: {{data.families.length}}</v-subheader>
                  <v-item
                    v-for="n in data.families"
                    :key="n"
                  >
                    <v-chip >
                      {{ n }}
                    </v-chip>
                  </v-item>
                </v-item-group>
              </v-expand-transition>
              <br v-if="showPerson">
              <br v-if="showPerson">
              <form enctype="multipart/form-data" v-show="showPerson">
                <input id="upload" type=file @input="upFile"  name="files[]">
              </form>
              <br v-if="showPerson">

            </v-card>
            <v-radio-group v-model="data.parentsAsistence">
              <v-radio
                v-for="n in parents"
                :key="n"
                :label="`${n}`"
                :value="n"
              ></v-radio>
            </v-radio-group>
            <v-checkbox
              :label="$t('event.create-form.requires_signature')"
              name="requires_signature"
              v-model="data.requires_signature"
            ></v-checkbox>
            <v-checkbox
              :label="$t('event.create-form.delegate_allowed')"
              name="delegate_allowed"
              v-model="data.delegate_allowed"
            ></v-checkbox>
            <v-select
                v-model="data.assistance_type"
                :error="validated.error"
                :error-messages="validated.message"
                :items="assistanceTypes"
                :label="$t('event.create-form.assistance_type')"
                item-text="label"
                item-value="value"
            ></v-select>
            <v-textarea
              :form="data"
              :label="$t('event.create-form.family_email')"
              v-model="data.family_email"
              :error-messages="validated.message"
              counter="2000"
              name="family_email"
              v-validate="'max:2000'"
            ></v-textarea>
            <v-textarea
              :form="data"
              :label="$t('event.create-form.responsible_email')"
              v-model="data.responsible_email"
              :error-messages="validated.message"
              counter="2000"
              name="description"
              v-validate="'max:2000'"
            ></v-textarea>
            <v-flex >
              <v-btn flat small @click="create" color="blue darken-1" >Actualizar</v-btn>
            </v-flex>
          </v-form>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
    import axios from 'axios'
    import XLSX from 'xlsx';
    export default {
        name: 'edit',

        data: () => ({
            first: true,
            showSchool: true,
            showExternal: true,
            showAll: true,
            showDegree: true,
            showPerson: true,
            selectDegrees: [],
            selectScool: [
                {
                    value: 'Preschool',
                    id: 'preschool'
                },
                {
                    value: 'Elementary',
                    id: 'Elementary'
                },
                {
                    value: 'Middle school',
                    id: 'middle_school'
                },
                {
                    value: 'High school',
                    id: 'high_school'
                },
                {
                    value: 'Admisiones',
                    id: 'admin'
                }
            ],
            parents: {
                'Padre': 'Padre',
                'Madre': 'Madre',
                'Ambos': 'Ambos'
            },
            dataExcel: [],
            resultFami: [],
            isLoading: false,
            search: '',
            validated: {
                message: '',
                error: false
            },
            category: [],
            data: {
                parentsAsistence: null,
                all: 0,
                degrees: [],
                delegate_allowed: 0,
                description: "modal",
                external_families: 0,
                families: [],
                id: 4,
                parents: "Padre",
                person: [],
                quotes_category_id: 1,
                requires_signature: 0,
                schools: [],
                assistance_type: '',
                family_email: '',
                responsible_email: '',
            },
            assistanceTypes: [
              { label: 'Presencial', value: 'FACEFACE' },
              { label: 'Virtual', value: 'ONLINE' },
              { label: 'Ambas', value: 'BOTH' },
            ]
        }),
        methods: {

            ExcelToJSON ()  {
                this.parseExcel = (file)=> {
                    let reader = new FileReader();

                    reader.onload = (e)=> {
                        let data = e.target.result;
                        let workbook = XLSX.read(data, {
                            type: 'binary'
                        });
                        workbook.SheetNames.forEach(function(sheetName) {
                            // Here is your object
                            let XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
                            let json_object = JSON.stringify(XL_row_object);
                            localStorage.setItem("dataExcel", JSON.stringify(XL_row_object));
                        })
                    };
                    reader.onerror = function(ex) {
                        console.log(ex);
                    };

                    reader.readAsBinaryString(file);
                };
            },
            handleFileSelect(evt) {
                var files = evt.target.files; // FileList object
                var xl2json = new this.ExcelToJSON();
                xl2json.parseExcel(files[0]);
                setTimeout(() => {
                    this.getUpLoaFile()
                }, 1500);
            },
            getUpLoaFile () {
                this.dataExcel = JSON.parse(localStorage.getItem("dataExcel"));
                let data = {
                    excelData: this.dataExcel
                }
                axios.post('/api/qoutes/families/get', data)
                    .then(resp=>{
                        console.log(resp);
                        this.resultFami = resp.data.data;
                        this.data.families = resp.data.seleted
                    })
            },
            upFile() {
                localStorage.removeItem("dataExcel");
                document.getElementById('upload').addEventListener('change', this.handleFileSelect, false);
            },
            validateSelct () {
                if(this.data.quotes_category_id == undefined) {
                    this.validated.message = 'Esta campo no puede estar vacío';
                    this.validated.error = true;
                    return true
                }
            },
            async getCategorysList() {
                this.loadingTable = true;
                const { data } = await axios.get('/api/qoute/category/show')
                this.category = data.map(obj=>{
                    return {
                        value: obj.id,
                        label: obj.description
                    }
                });
                this.loadingTable = false;
            },
            schoolGrades (){
                axios.get('api/school_grades')
                    .then(resp=>{
                        this.selectDegrees = resp.data
                    })
            },
            async create() {
                this.validateSelct()
                //if (await this.formHasErrors()) return

                const result = await axios.post('/api/qoutes/update', this.data)
                    .then(resp=>{
                        this.$store.dispatch('responseMessage', {
                            type: 'success',
                            text: this.$t('eventcategorys.create-form.stored-ok-text'),
                            title: this.$t('eventcategorys.create-form.stored-ok-title'),
                            modal: true
                        })
                        this.showSchool = true
                        this.showAll = true
                        this.showDegree = true
                        this.showPerson = true
                        this.$emit("edit")
                    }).catch(erro=>{
                        this.$store.dispatch('responseMessage', {
                            type: 'error',
                            text: 'Se presento un error, por favor intente de nuevo',
                            title: 'Noticia',
                            modal: true
                        })

                    })


            },

            changeSchools(){
                if(this.data.schools.length>0){
                    this.showDegree = false;
                    this.showExternal = false;
                    this.showPerson = false;
                    this.showAll = false;
                    this.data.degrees = [];
                    this.data.currentFamilySearch = [];

                }else {
                    this.showAll = true;
                    this.showExternal = true;
                    this.showPerson = true;
                    this.showDegree = true;
                }
            },
            changeshowDegree(){
                if(this.data.degrees.length>0){
                    this.showSchool = false;
                    this.showExternal = false;
                    this.showPerson = false;
                    this.showAll = false;
                    this.data.schools = [];
                    this.data.currentFamilySearch = [];

                }else {
                    this.showAll = true;
                    this.showExternal = true;
                    this.showPerson = true;
                    this.showSchool = true;
                }
            },
            changeExternal(){
                if(this.data.external){
                    this.showSchool = false;
                    this.showDegree = false;
                    this.showPerson = false;
                    this.showAll = false;
                    this.data.schools = [];
                    this.data.degrees = [];
                    this.data.currentFamilySearch = [];

                }else {
                    this.showAll = true;
                    this.showExternal = true;
                    this.showPerson = true;
                    this.showSchool = true;
                }
            },
            changecurrentFamilySearch(){
                if(this.form.currentFamilySearch>0){
                    this.showExternal = false;
                    this.showSchool = false;
                    this.showDegree = false;
                    this.showAll = false;
                    this.data.schools = [];
                    this.data.degrees = [];

                }else {
                    this.showAll = true;
                    this.showExternal = true;
                    this.showPerson = true;
                    this.showSchool = true;
                }
            },
            async getEdit(item) {
                this.showAll = true
                this.showDegree = true
                this.showPerson = true
                await this.getCategorysList()
                await this.schoolGrades()
                this.data = item
                this.data.parentsAsistence = item.parents
                this.data.all = item.all== "1"
                this.data.external_families = item.external_families== "1"
                this.data.requires_signature = item.requires_signature== "1"
                this.data.delegate_allowed = item.delegate_allowed== "1"

                this.data.assistance_type = item.assistance_type
                this.data.family_email = item.family_email
                this.data.responsible_email = item.responsible_email

                console.log(item, 'item')
                if (item.families.length > 2){
                  let selected_families = []
                    item.families
                      .slice(1,-1)
                      .split(',')
                      .map(family => selected_families.push(family.trim()));

                    this.data.families = selected_families
                    this.changecurrentFamilySearch()
                } else {
                  this.data.families = []
                }
                if (item.degrees.length > 2){
                  let selected_degrees = []
                    item.degrees
                      .slice(1,-1)
                      .split(',')
                      .map(degree => selected_degrees.push(parseInt(degree.trim(), 10)));

                    this.data.degrees = selected_degrees
                    this.changeshowDegree()
                } else {
                  this.data.degrees = []
                }

                if (item.schools.length > 2) {
                    let selected_schools = []
                    item.schools
                      .slice(1,-1)
                      .split(',')
                      .map(school => selected_schools.push(school.slice(1,-1).trim()));
                    console.log(selected_schools)
                    this.data.schools = selected_schools
                    this.changeSchools()
                } else {
                  this.data.schools = []
                }
            },
        },
        watch: {


            'data.all': function (val){
                this.showSchool = true;
                this.showDegree = true;
                this.showPerson = true;
                this.showExternal = true;
                if (val){
                    this.showSchool = false;
                    this.showDegree = false;
                    this.showExternal = false;
                    this.showPerson = false;
                    this.data.schools = [];
                    this.data.degrees = [];
                    this.data.families = [];
                    this.first = false
                }
            },
            search: function(val){
                if (val==null || val=='') {
                    this.isLoading = false
                    return
                }

                if (this.isLoading) return
                this.isLoading = true

                axios.get(`/api/qoutes/families/` + val)
                    .then(res => {
                        this.resultFami = []
                        this.isLoading = false
                        const { data } = res
                        this.count = data.length;
                        this.resultFami = data;
                    })
                    .catch(err => {
                        this.isLoading = false
                        console.log(err)
                    })
                    .finally(() => (this.isLoading = false))
            }

        }
    }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/quotes/edit.vue